"use client";

import { useState, type FC } from "react";
import { useLocale, useTranslations } from "next-intl";

import { Icon } from "@/ui/components/primitives/Icon";
import { TextBody } from "@/ui/components/typography/TextBody";
import { cn } from "@/ui/lib/utils";
import {
  FOOTER_COUNTRY_OPTIONS,
  FOOTER_COUNTRY_TOGGLE_BUTTON_CLASS_NAME,
  type TFooterCountryToggleProps,
} from "@/ui/components/navigation/Footer/Footer.config";
import {
  switchRegionAndReload,
  toSupportedLocale,
} from "@/ui/components/navigation/Footer/Footer.utils";
import {
  FooterCountrySelectDrawer,
} from "@/ui/components/navigation/Footer/FooterCountrySelectDrawer";

export const FooterCountryToggle: FC<TFooterCountryToggleProps> = ({
  onCountryChange = switchRegionAndReload,
  className,
}) => {
  const t = useTranslations("Components.Footer.CountryToggle");
  const currentLocale = toSupportedLocale(useLocale());
  const [ isDrawerOpen, setIsDrawerOpen ] = useState(false);

  const { icon, currency } = FOOTER_COUNTRY_OPTIONS[currentLocale];
  const country = t(`Countries.${currentLocale}`);

  return (
    <>
      <button
        type="button"
        data-component="FooterCountryToggle"
        aria-label={t("toggleAriaLabel", { country })}
        aria-haspopup="dialog"
        onClick={() => setIsDrawerOpen(true)}
        className={cn(FOOTER_COUNTRY_TOGGLE_BUTTON_CLASS_NAME, className)}
      >
        <Icon icon={icon} size="md" className="shrink-0" />
        <TextBody tag="span" size={2} isResponsive={false} className="whitespace-pre">
          { `${country}  ·  ${currency}` }
        </TextBody>
      </button>
      <FooterCountrySelectDrawer
        open={isDrawerOpen}
        onOpenChange={setIsDrawerOpen}
        currentLocale={currentLocale}
        onConfirm={onCountryChange}
      />
    </>
  );
};

FooterCountryToggle.displayName = "FooterCountryToggle";
